export default {
    deleteMessageManyItems:
        '現在、「{{name}}」のタグ付けられている書類が{{count}}通ございます。タグを削除することで、これらの書類からもタグが削除されます。書類そのものは削除されません。',
    deleteMessageNoItem: '「{{name}}」とタグ付けされている書類はございません。',
    deleteMessageOneItem:
        '現在、「{{name}}」のタグ付けられている書類が１通ございます。タグを削除することで、これらの書類からもタグが削除されます。書類そのものは削除されません。',
    deleteTag: 'このタグを削除してよろしいですか？',
    name: 'タグ名',
    remove: '削除',
    rename: '編集',
    renameTag: 'タグ名を編集',
    subtitle:
        '既存の書類に設定されているタグを編集すると、新タグ名が該当の書類に反映されます。他のタグ名と同じ名称に編集すると、タグを統合することができます。',
    subtitleEmpty: '書類をタグ付けすると、こちらで一覧として表示されます。',
    title: 'タグの管理',
};
